// extracted by mini-css-extract-plugin
export default {"pickerCont":"EmojiPicker_pickerCont__mCAKO","emojiBtn":"EmojiPicker_emojiBtn__hEQ9y"};